import { CommonModule } from '@angular/common';
import {
    Component,
    Input,
    InputSignal,
    OnInit,
    effect,
    inject,
    input,
    untracked,
} from '@angular/core';
import {
    FormBuilder,
    FormControl,
    FormGroup,
    ReactiveFormsModule,
    Validators,
} from '@angular/forms';

@Component({
    selector: 'iq-control-text-text',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule],
    templateUrl: './iq-control-text-text.component.html',
    styleUrl: './iq-control-text-text.component.scss',
})
export class IqControlTextTextComponent implements OnInit {
    @Input()
    fg: FormGroup = new FormGroup({});

    private _fb: FormBuilder = inject(FormBuilder);

    randomName: string =
        'iq-control-text-percent-' + Math.random().toString(36).substring(7);
    id: InputSignal<string> = input('');
    placeholder: InputSignal<string> = input('');
    value: InputSignal<string> = input('');
    name: InputSignal<string> = input('');
    disabled: InputSignal<boolean> = input(null);
    minLength: InputSignal<number> = input(null);
    maxLength: InputSignal<number> = input(null);
    required: InputSignal<boolean> = input(false);
    inputControl: FormControl;

    constructor() {
        effect(() => {
            const name = this.name();

            untracked(() => {
                if (!!name?.length && !this.fg.get(name)) {
                    this.fg.addControl(
                        this.name(),
                        this._fb.control(this.value()),
                    );
                    this.inputControl = this.fg.get(this.name()) as FormControl;

                    if (this.required()) {
                        this.inputControl.setValidators(Validators.required);
                    }
                }
            });
        });
        effect(() => {
            const value = this.value();

            untracked(() => {
                this.inputControl.setValue(value);
            });
        });
    }

    ngOnInit(): void {
        if (!!this.fg && !this.fg.get(this.name()))
            this.fg.addControl(this.name(), this._fb.control(this.value()));
        
        this.inputControl = this.fg.get(this.name()) as FormControl;
    }
}
